import { FlexBox } from "@brg/ui";
import { LayoutConst } from "core";
import styled from "styled-components";

export const NominationContainer = styled(FlexBox)<{extraPadding?: boolean}>`
    width: 100%;
    flex-flow: column;
    margin-top: 24px;
    max-width: ${LayoutConst.projectContainer.l}px;
    margin: 24px auto 0 auto;

    @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
        max-width: ${LayoutConst.projectContainer.m}px;
    }

    @media (max-width: ${LayoutConst.screen.m}px) {
        // max-width: calc(${LayoutConst.competitionCard.s.w * 2}px + 24px);
        max-width: 100%;
        margin: 24px auto 0 auto;
        // padding: 0 36px;
    }

    @media (max-width: ${LayoutConst.screen.md}px) {
        // max-width: calc(${LayoutConst.competitionCard.s.w * 2}px + 24px);
        max-width: 100%;
        margin: 24px auto 0 auto;
        padding: ${({ extraPadding }) =>  extraPadding ? '0 36px' : '0 0 0 0'};
    }

    @media (max-width: ${LayoutConst.screen.s}px) {
        // max-width: calc(${LayoutConst.competitionCard.s.w * 2}px + 16px);
        padding: ${({ extraPadding }) =>  extraPadding ? '0 10px' : '0 0 0 0'};
    }
`;

export const Label = styled.div`
    font-family: Inter;
    font-size: 30px;
    font-style: normal;
    font-weight: 600;
    line-height: 40px;
    letter-spacing: -0.6px;
    color: ${({ theme }) => theme.competition.nominationsBlock.label.color};

    @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
        font-size: 23px;
        line-height: 27px;
    }

    @media (max-width: ${LayoutConst.screen.s-1}px) {
        font-size: 20px;
        line-height: 25px;
    }
`;import { FlexBox } from "@brg/ui";
import { LayoutConst } from "core";
import styled from "styled-components";

export const NominationContainer = styled(FlexBox)<{extraPadding?: boolean}>`
    width: 100%;
    flex-flow: column;
    margin-top: 24px;
    max-width: ${LayoutConst.projectContainer.l}px;
    margin: 24px auto 0 auto;

    @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
        max-width: ${LayoutConst.projectContainer.m}px;
    }

    @media (max-width: ${LayoutConst.screen.m}px) {
        // max-width: calc(${LayoutConst.competitionCard.s.w * 2}px + 24px);
        max-width: 100%;
        margin: 24px auto 0 auto;
        // padding: 0 36px;
    }

    @media (max-width: ${LayoutConst.screen.md}px) {
        // max-width: calc(${LayoutConst.competitionCard.s.w * 2}px + 24px);
        max-width: 100%;
        margin: 24px auto 0 auto;
        padding: ${({ extraPadding }) =>  extraPadding ? '0 36px' : '0 0 0 0'};
    }

    @media (max-width: ${LayoutConst.screen.s}px) {
        // max-width: calc(${LayoutConst.competitionCard.s.w * 2}px + 16px);
        padding: ${({ extraPadding }) =>  extraPadding ? '0 10px' : '0 0 0 0'};
    }
`;

export const Label = styled.div`
    font-family: Inter;
    font-size: 30px;
    font-style: normal;
    font-weight: 600;
    line-height: 40px;
    letter-spacing: -0.6px;
    color: ${({ theme }) => theme.competition.nominationsBlock.label.color};

    @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
        font-size: 23px;
        line-height: 27px;
    }

    @media (max-width: ${LayoutConst.screen.s-1}px) {
        font-size: 20px;
        line-height: 25px;
    }
`;